import graphql from './graphql';

const query = /* GraphQL */ `
  query deleteObject($key: String) {
    deleteObject(key: $key) {
      success
    }
  }
`;

const S3DeleteObject = async key => graphql(query, { key }).then(({ deleteObject }) => deleteObject);
export default S3DeleteObject;
